import { render } from "./MyMiracles.vue?vue&type=template&id=5ded926c&scoped=true&bindings={\"miracles\":\"data\",\"loading\":\"data\",\"location\":\"data\",\"deleteMiracle\":\"options\",\"getMiracles\":\"options\",\"copyUrl\":\"options\"}"
import script from "./MyMiracles.vue?vue&type=script&lang=js"
export * from "./MyMiracles.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5ded926c"

export default script